/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type InteriorPhotoWrapper_viewer = {
    readonly tradePhotosQuery: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly projectId: string | null;
                readonly projectRootId: string | null;
                readonly firmName: string | null;
                readonly photo: {
                    readonly name: string | null;
                    readonly url: string | null;
                    readonly serviceId: string | null;
                    readonly " $fragmentRefs": FragmentRefs<"PhotoContainer_tradePhoto" | "RailContainer_tradePhoto">;
                } | null;
                readonly " $fragmentRefs": FragmentRefs<"RailContainer_photoQuery" | "PhotoContainer_photoQuery">;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "InteriorPhotoWrapper_viewer";
};
export type InteriorPhotoWrapper_viewer$data = InteriorPhotoWrapper_viewer;
export type InteriorPhotoWrapper_viewer$key = {
    readonly " $data"?: InteriorPhotoWrapper_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"InteriorPhotoWrapper_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "InteriorPhotoWrapper_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "urlLabels",
      "type": "[String!]!"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tradePhotosQuery",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "urlLabels",
          "variableName": "urlLabels"
        }
      ],
      "concreteType": "TradePhotoQueryConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "TradePhotoQueryEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "TradePhotosQueryOutput",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "projectId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "projectRootId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "firmName",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "photo",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TradePhoto",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "name",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "url",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "serviceId",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "PhotoContainer_tradePhoto",
                      "args": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "RailContainer_tradePhoto",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "FragmentSpread",
                  "name": "RailContainer_photoQuery",
                  "args": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "PhotoContainer_photoQuery",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'c26f1f0b52106fd0e81406b3fefcdf50';
export default node;
